import { NOT_IMPLEMENTED } from ".";
import { CancellationPenalty, CancellationPenaltyCalculationType, Price, ProductPriceTypeSchema } from "../types";
import { generateCancellationPenaltyFormattedTextTravelDate } from "./generateCancellationPenaltyFormattedTextTravelDate";

export type CancellationPenaltyFormattedTextParams = {
    languageCode: string;
    totalPrice?: Pick<Price, "gross" | "currency">;
    formattedPenaltyIndex: number;
    cancellationPenaltyList: CancellationPenalty[];
    calculationType?: CancellationPenaltyCalculationType;
};

export function generateCancellationPenaltyFormattedText(params: CancellationPenaltyFormattedTextParams) {
    const { totalPrice, formattedPenaltyIndex, cancellationPenaltyList } = params;
    const cancellationPenalty = cancellationPenaltyList[formattedPenaltyIndex];
    if (!cancellationPenalty) {
        return "";
    }

    // For now, determines product price type locally based on total price.
    // This will eventually be replaced with the product price type passed from higher-level.
    // And can support different price types such as Free, Standard, Reservation, etc.
    const productPriceType = totalPrice
        ? totalPrice.gross > 0
            ? ProductPriceTypeSchema.Enum.PAID
            : ProductPriceTypeSchema.Enum.FREE
        : undefined;

    const relativeTo = cancellationPenalty.relativeTo;
    if (relativeTo === "TRAVEL_DATE") {
        return generateCancellationPenaltyFormattedTextTravelDate({
            ...params,
            priceType: productPriceType,
        });
    }

    return NOT_IMPLEMENTED;
}
